export const awsDateTimeMdy = (dateTime) => {
  const date = new Date(dateTime);
  return date.toLocaleString();
};

export const awsDateMdy = (dateTime) => {
  const date = new Date(dateTime);
  return date.toLocaleDateString("en-US");
};

export const awsDateToIso8601 = (dateTime) => {
  const date = new Date(dateTime)
  const formattedDate = date.toISOString().slice(0, 16)
  return formattedDate
}

/**
 * Convert a date string in the format of 'MM dd yyy - 00:00 AM/PM' to an 
 * ISO 8601 date string.
 * @param {*} dateTime 
 * @returns 
 */
export const toAwsDateTime = (dateTime) => {
  let options = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }
  let formatted = dateTime.toLocaleString("en-US", options)
  let [month, day, year, hours, minutes, seconds] = formatted.match(/\d+/g)

  // Format as '0000-00-00T00:00:00Z'
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`
}

/**
 * Convert an ISO 8601 date string to a date string in the format of 'MM dd yyy - 00:00 AM/PM'
 * @param {*} isoDateString
 * @param {*} format Options are 'm d y - h m ampm' or 'd m y (h m ampm)'
 * @returns Custom date/time string
 */
export const isoDateToMdyTime = (
  isoDateString,
  format = "m d y - h m ampm"
) => {
  const date = new Date(isoDateString);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = monthNames[date.getUTCMonth()];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  let finalFormat = `${month} ${day}, ${year} - ${hours}:${minutes} ${ampm}`;
  if (format === "d m y (h m ampm)") {
    finalFormat = ` ${day} ${month} ${year} (${hours}:${minutes} ${ampm})`;
  }

  return finalFormat;
};

/**
 * Convert datetime format from '2023-06-01T17:30:43.974Z' to 'June 1, 2023'.
 * @param {*} dateTime
 * @returns Returns a string in the format 'June 1, 2023'.
 */
export const awsDateToMMddyyyy = (dateTime) => {
  const date = new Date(dateTime);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const day = date.getUTCDate();
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  const formattedDate = `${month} ${day}, ${year}`;
  return formattedDate;
};
